(function () {
  if (window.__sabaskinFreeShippingBarInit) return;
  window.__sabaskinFreeShippingBarInit = true;

  var GOAL_CENTS = 250000 * 100; // $250.000 COP

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function updateBar() {
    var text = document.getElementById('sabaskin-free-shipping-text');
    var fill = document.getElementById('sabaskin-free-shipping-fill');
    if (!text || !fill) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;

        if (total >= GOAL_CENTS) {
          text.innerHTML = '🎉 ¡Tienes envío GRATIS!';
          fill.style.width = '100%';
        } else {
          var missing = GOAL_CENTS - total;
          text.innerHTML = 'Te faltan <strong>' + formatMoney(missing) + '</strong> para tu envío GRATIS';
          var pct = Math.max(2, (total / GOAL_CENTS) * 100);
          fill.style.width = pct + '%';
        }
      })
      .catch(function () {});
  }

  function init() {
    updateBar();

    var target = document.querySelector('cart-items-component');
    if (!target) return;

    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(updateBar, 250);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();